module.exports = __webpack_public_path__ + "static/media/user_plus.fb05034b.svg";